/**
 * Defined all chanel for socket client comunication with socket server
 */
export default {
    SEVER_MQTT_MSG: 'SEVER_MQTT_MSG',
    SUB_REQUEST: 'SUB_REQUEST',
    SUB_RESULTRQ: 'SUB_RESULTRQ',
    CLIENT_REQUEST: 'CLIENT_REQUEST',
    SEVER_RESULTRQ: 'SEVER_RESULTRQ',
};
